import React from 'react';
import { motion } from 'framer-motion';

interface MotionDivProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  variant?: 'fadeUp' | 'fadeIn' | 'slideLeft' | 'slideRight' | 'scale' | 'bounce' | 'stagger';
  duration?: number;
  hover?: boolean;
}

const MotionDiv: React.FC<MotionDivProps> = ({ 
  children, 
  className = '', 
  delay = 0, 
  variant = 'fadeUp',
  duration = 0.5,
  hover = false
}) => {
  const variants = {
    fadeUp: {
      initial: { opacity: 0, y: 20 },
      animate: { opacity: 1, y: 0 },
      transition: { duration, delay, ease: "easeOut" }
    },
    fadeIn: {
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      transition: { duration, delay, ease: "easeOut" }
    },
    slideLeft: {
      initial: { opacity: 0, x: -30 },
      animate: { opacity: 1, x: 0 },
      transition: { duration, delay, ease: "easeOut" }
    },
    slideRight: {
      initial: { opacity: 0, x: 30 },
      animate: { opacity: 1, x: 0 },
      transition: { duration, delay, ease: "easeOut" }
    },
    scale: {
      initial: { opacity: 0, scale: 0.8 },
      animate: { opacity: 1, scale: 1 },
      transition: { duration, delay, ease: "easeOut" }
    },
    bounce: {
      initial: { opacity: 0, y: -20 },
      animate: { opacity: 1, y: 0 },
      transition: { duration, delay, type: "spring", bounce: 0.4 }
    },
    stagger: {
      initial: { opacity: 0, y: 20 },
      animate: { opacity: 1, y: 0 },
      transition: { duration, delay, ease: "easeOut", staggerChildren: 0.1 }
    }
  };

  const selectedVariant = variants[variant];
  
  const hoverProps = hover ? {
    whileHover: { 
      scale: 1.02, 
      transition: { duration: 0.2 } 
    },
    whileTap: { 
      scale: 0.98 
    }
  } : {};

  return (
    <motion.div
      initial={selectedVariant.initial}
      animate={selectedVariant.animate}
      transition={selectedVariant.transition}
      className={className}
      {...hoverProps}
    >
      {children}
    </motion.div>
  );
};

export default MotionDiv;
